/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Wed Feb 22 2023 3:16:54 PM
 *
 *******************************************************/
//@flow

import React, { Component } from 'react';
import { Card, Grid, Icon, Link } from '@shopify/polaris';
import { withI18n } from '@shopify/react-i18n';
import { LockMinor, ExternalSmallMinor } from '@shopify/polaris-icons';
import { URL } from 'src/constants/links';

import Rocket from 'src/assets/images/common/rocket.svg';
import LockFeature01 from 'src/assets/images/variant-display/lock-feature-01.png';
import LockFeature02 from 'src/assets/images/variant-display/lock-feature-02.png';
import LockFeature03 from 'src/assets/images/variant-display/lock-feature-03.png';

class PremiumLockCard extends Component<Props> {
  render() {
    const { i18n, disableLockUnLock, addonVariantDisplayStatus } = this.props;

    return (
      <div className="premium-lock-card">
        <Card>
          <Card.Section>
            <Grid>
              <Grid.Cell columnSpan={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <div className="detail">
                  <p className="title">
                    <img src={Rocket} alt="rocket" />
                    {i18n.translate('AdminHTML.VariantsDisplay.PremiumFeature.title01')}
                  </p>
                  <p className="content">
                    {i18n.translate('AdminHTML.VariantsDisplay.PremiumFeature.content01')}
                  </p>
                  <div className="action">
                    <div
                      className={`Polaris-Button ${
                        disableLockUnLock ? 'unlock-button-disabled' : ''
                      }`}
                      onClick={this.handleUnlock}>
                      <Icon source={LockMinor} />
                      {i18n.translate(
                        `AdminHTML.Common.Action.${
                          addonVariantDisplayStatus === 'restoreVariantDisplay'
                            ? 'unLockNow'
                            : 'unlockFeatureForTrial'
                        }`
                      )}
                    </div>
                    <Link external url={URL['Link_V2_Tool_VariantDisplay_Doc']}>
                      {i18n.translate('AdminHTML.Common.Action.learnMore')}
                      <Icon source={ExternalSmallMinor} color={'interactive'}></Icon>
                    </Link>
                  </div>
                </div>
              </Grid.Cell>
              <Grid.Cell columnSpan={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <img
                  src={LockFeature01}
                  alt={i18n.translate('AdminHTML.VariantsDisplay.PremiumFeature.title01')}
                />
              </Grid.Cell>
            </Grid>
          </Card.Section>
          <Card.Section>
            <Grid>
              <Grid.Cell columnSpan={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <img
                  src={LockFeature02}
                  alt={i18n.translate('AdminHTML.VariantsDisplay.PremiumFeature.title02')}
                />
              </Grid.Cell>
              <Grid.Cell columnSpan={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <div className="detail">
                  <p className="title">
                    <img src={Rocket} alt="rocket" />
                    {i18n.translate('AdminHTML.VariantsDisplay.PremiumFeature.title02')}
                  </p>
                  <p className="content">
                    {i18n.translate('AdminHTML.VariantsDisplay.PremiumFeature.content02')}
                  </p>
                </div>
              </Grid.Cell>
            </Grid>
          </Card.Section>
          <Card.Section>
            <Grid>
              <Grid.Cell columnSpan={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <div className="detail">
                  <p className="title">
                    <img src={Rocket} alt="rocket" />
                    {i18n.translate('AdminHTML.VariantsDisplay.PremiumFeature.title03')}
                  </p>
                  <p className="content">
                    {i18n.translate('AdminHTML.VariantsDisplay.PremiumFeature.content03')}
                  </p>
                </div>
              </Grid.Cell>
              <Grid.Cell columnSpan={{ xs: 12, sm: 6, md: 6, lg: 6, xl: 6 }}>
                <img
                  src={LockFeature03}
                  alt={i18n.translate('AdminHTML.VariantsDisplay.PremiumFeature.title03')}
                />
              </Grid.Cell>
            </Grid>
          </Card.Section>
        </Card>
      </div>
    );
  }
  handleUnlock = () => {
    const { action, disableLockUnLock } = this.props;
    if (disableLockUnLock) return;
    action();
  };
}

export default withI18n()(PremiumLockCard);
